import { memo } from 'react';

import { NoteFilterOptions, NoteFilters } from '@/forms/NoteFilterForm/types';
import SharedActiveFilters from '@/ui/components/ActiveFilters';
import buildActiveFilterGroups from '@/utils/buildActiveFilterGroups';
import removeFilter from '@/utils/removeFilter';

interface Props {
  filterOptions: NoteFilterOptions;
  filters: Partial<NoteFilters>;
  setFilters: (filters: Partial<NoteFilters>) => void;
  values: Partial<NoteFilters>;
}

const ActiveFilters = ({ filterOptions, filters, setFilters, values }: Props) => {
  const getNoteTypeName = (noteTypeId: string): string =>
    filterOptions.noteTypes.find((noteType) => noteType.id === noteTypeId)?.title ?? '';

  const formatFilterValue = (value: string, filterName: string) => {
    switch (filterName) {
      case 'note_type':
        return getNoteTypeName(value);
      default:
        return value;
    }
  };

  return (
    <SharedActiveFilters
      groups={buildActiveFilterGroups({
        filters,
        formatValue: formatFilterValue,
        hiddenFilters: ['ordering', 'page'],
        labels: { note_type: 'Note Type' }
      })}
      onClearAll={() => setFilters({})}
      onRemove={(filterName, filterValue) =>
        removeFilter({ activeFilters: filters, filterName, filterValue, setFilters, values })
      }
    />
  );
};

export default memo(ActiveFilters);
